export const INVITATION_ERROR = {
  401: '操作失败，请刷新后重试',
  E0010216: '邀请已失效',
};
